import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SiteSettingsContext = createContext();

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within SiteSettingsProvider');
  }
  return context;
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to load settings:', error);
      // Set default values if API fails
      setSettings({
        phone1: '(440) 381-7828',
        phone2: '(216) 695-1565',
        email: 'Buildbroz25@gmail.com',
        service_area: 'Cleveland, OH and surrounding areas',
        slogan: "Let's Build It",
        company_name: 'BuildBroz',
        about_text: 'BuildBroz brings 15 years of expert residential remodeling experience to Cleveland and surrounding areas.',
        home_hero_title: 'Transform Your Home',
        home_hero_subtitle: 'Expert residential remodeling services in Cleveland, Ohio with 15 years of experience'
      });
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    loadSettings();
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};
